const platformPayButton = {
  alreadyOpenInAnotherTab:
    "Payment sheet is open in another tab or window. Close it there, then try again.",
  fullscriptOrder: "Fullscript order",
  labShipping: {
    label: "Lab processing",
    detail: "No shipping required",
  },
  orderFailedError: "We couldn't complete your payment. Please try again.",
  savings: "Savings",
  sheetUnresponsiveError: "Please try again",
  shipping: "Shipping",
  subtotal: "Subtotal",
  tax: "Tax",
} as const;

export { platformPayButton };
